import React from 'react'

import type { AssetSource } from 'EditorApp/types'
import VideoWithSources from 'components/VideoWithSources'

interface Props {
  source: AssetSource
  style: React.CSSProperties
}

const VideoOrImage = ({ source, style }: Props) => {
  if (source.formats.length) {
    return <VideoWithSources source={source} style={style} />
  } else {
    return <img src={source.url} style={style} />
  }
}

export default VideoOrImage
